import React from "react";
export const EditIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.69299 7.84904L9.68896 7.84501L15.268 2.26599L13.002 0L11.3821 1.61991H11.375L10.375 2.61991H10.3821L6.56728 6.4347L6.56559 6.43301L6.56374 6.43825L6.54987 6.45212L6.5565 6.45874L5.31836 9.96261L8.84802 8.71541L8.83732 8.70471L9.69299 7.84904ZM13 6.74589V13.2866C13 14.023 12.403 14.6199 11.6667 14.6199H2.33333C1.59695 14.6199 1 14.023 1 13.2866V3.95325C1 3.21687 1.59695 2.61991 2.33333 2.61991H8.02612L9.02612 1.61991H2.33333C1.04467 1.61991 0 2.66458 0 3.95325V13.2866C0 14.5752 1.04467 15.6199 2.33333 15.6199H11.6667C12.9553 15.6199 14 14.5752 14 13.2866V5.74589L13 6.74589Z"
      fill="#979797"
    />
  </svg>
);
